import Page from "webPage/Page";
import ScriptHelper from "base/ScriptHelper";

Page.register('page-template-the-guesthouse', () => {
    if ($('.js-google-map').length > 0) {
        loadGoogleMap($('.js-google-map'));
    }
});

export function loadGoogleMap($element) {
    ScriptHelper.load_script("https://maps.googleapis.com/maps/api/js?key=AIzaSyCRDzsMj3LCi67afh7k9FDNwBSWE179rus").then(() => {
        loadMap($element);
    });
}

function loadMap($element) {
    let markers = {};

    try {
        markers = JSON.parse($('.js-marker-locations').text());
    } catch (e) {
        console.log('Could not load map markers', e);
    }

    const mapOptions = {
        disableDefaultUI:  false,
        center:            new google.maps.LatLng(0, 0),
        styles:            MAP_STYLES,
        gestureHandling:   'cooperative',
        backgroundColor:   '#FFF',
        zoomControl:       false,
        mapTypeControl:    false,
        scaleControl:      true,
        streetViewControl: false,
        rotateControl:     true,
        fullscreenControl: false,
        zoom:              17,
        mapTypeId:         google.maps.MapTypeId.ROADMAP,
    };


    let map = new google.maps.Map($element[0], mapOptions);

    map.markers = [];

    initMarker({
        parking_latitude: 50.215770,
        parking_longitude: -5.477780,
        parking_address: '1 Bethesda Place St Ives, TR26 1PA',
        parking_title: 'Cornerways Guest House',
        parking_type: 'main'
    }, map)

    if(markers.length > 0 ){
        markers.forEach((marker) => {
            initMarker(marker, map);
        });
    }

    centerMap(map);
}

function initMarker(markerData, map) {
    let infowindow;
    let latLng = {
        lat: parseFloat(markerData.parking_latitude),
        lng: parseFloat(markerData.parking_longitude)
    };
    let type = 'undefined' === typeof markerData.parking_type ? 'parking' : markerData.parking_type;

    let marker = new google.maps.Marker({
        position: latLng,
        map:      map,
        icon:     {
            url:         '/wp-content/themes/cornerways/images/svg/'+ type +'-marker.svg',
            scaledSize:  new google.maps.Size(45, 65),
            labelOrigin: new google.maps.Point(22, 65),
        }
    });

    marker.addListener('click', function () {
        if (infowindow) infowindow.close();

        let $content = (
            eotwJSXFactory('div', {class: "map-tooltip"}, [
                eotwJSXFactory('h2', {class: "heading map-tooltip__heading"}, [markerData.parking_title]),
                eotwJSXFactory('p', null, [markerData.parking_address]),
                eotwJSXFactory('a', {className: "map-tooltip__link", target: "_blank", rel: "noreferrer", href: 'https://www.google.com/maps/dir/?api=1&destination=' + markerData.parking_title}, ["Get directions"])
            ])
        );

        infowindow = new google.maps.InfoWindow({
            content: $content[0]
        });

        infowindow.open(map, marker);
    });

    map.markers.push(marker);
}

function centerMap(map) {
    let bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    if (map.markers.length === 1) {
        map.setCenter(bounds.getCenter());
    } else {
        map.fitBounds(bounds);
    }
}

const MAP_STYLES = [
    {
        "elementType": "geometry",
        "stylers":     [
            {
                "color": "#F4F9F8"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers":     [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers":     [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers":     [
            {
                "color": "#F5F5F5"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers":     [
            {
                "color": "#BDBDBD"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers":     [
            {
                "color": "#E9F2F1"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers":     [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers":     [
            {
                "color": "#E9F2F2"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers":     [
            {
                "color": "#9E9E9E"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers":     [
            {
                "color": "#FFFFFF"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers":     [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers":     [
            {
                "color": "#CCE0DE"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers":     [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers":     [
            {
                "color": "#9E9E9E"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers":     [
            {
                "color": "#E9F2F2"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers":     [
            {
                "color": "#DEEBED"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers":     [
            {
                "color": "#D9E7E7"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers":     [
            {
                "color": "#828282"
            }
        ]
    }
];
